/* global google */

const wrapHelper = (nodesToWrap,className = ['facetwp-checkbox-group']) => {

  let addedToDocument = false;
  const wrapper = document.createElement("div");
  wrapper.classList.add(...className);

  for (var index = 0; index < nodesToWrap.length; index++) {
    const node = nodesToWrap[index];
    if (! addedToDocument) {
      node.parentNode.insertBefore(wrapper, node);
      addedToDocument = true;
    }
    node.parentNode.removeChild(node);
    wrapper.appendChild(node);
  }

}


const facetMarkup = () => {
  const wrappers = document.querySelectorAll('.c-quicknav:not(.c-quicknav--subfilter) .facetwp-facet[data-type="checkboxes"]');

  if (wrappers.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < wrappers.length; i++) {
        const multiLevelBoxes = wrappers[i].querySelectorAll('.facetwp-depth');
        if(multiLevelBoxes.length) {
          for (let j = 0; j < multiLevelBoxes.length; j++) {
            wrapHelper([multiLevelBoxes[j].previousElementSibling,multiLevelBoxes[j]]);
          }
        } else {
          const singleLevelBoxes = wrappers[i].querySelectorAll(':scope > .facetwp-checkbox');
          if(singleLevelBoxes.length) {
            for (let k = 0; k < singleLevelBoxes.length; k++) {
              wrapHelper([singleLevelBoxes[k]],['facetwp-checkbox-group', 'facetwp-checkbox-single']);
            }
          }
        }

        const singleLevelBoxes = wrappers[i].querySelectorAll(':scope > .facetwp-checkbox');
        if(singleLevelBoxes.length) {
          for (let h = 0; h < singleLevelBoxes.length; h++) {
            wrapHelper([singleLevelBoxes[h]]);
          }
        }
      }

  }
};

const facetMapsAutocomplete = () => {
    if(FWP.facets.location_geo) {
      localStorage.setItem('location_geo', FWP.facets.location_geo);
    }
    if(FWP.facets.service_geo) {
      localStorage.setItem('service_geo', FWP.facets.service_geo);
    }
    FWP.hooks.addAction('facetwp/refresh/proximity', function() {
      if (window.innerWidth > 768) {
        if((FWP.facets.location_geo && FWP.facets.location_geo != localStorage.getItem('location_geo')) || (FWP.facets.service_geo && FWP.facets.service_geo != localStorage.getItem('service_geo'))) {
          const currentTabLink = document.querySelector('.c-quicknav__label.--active');
          if (currentTabLink) {
            currentTabLink.classList.remove('--active');
          }

          const currentTabContent = document.querySelector('.c-quicknav__content.--active');
          if (currentTabContent) {
            currentTabContent.classList.remove('--active');
          }
        }
      }
    },100);
}

document.addEventListener('facetwp-loaded', () => facetMapsAutocomplete());
document.addEventListener('facetwp-loaded', () => facetMarkup());
document.addEventListener('facetwp-refresh', () => facetMarkup());
